export const alpha2List = {
  CL: 'cl',
  AR: 'ar',
  CO: 'co',
  BR: 'br',
  MX: 'mx',
  US: 'us',
};
